const initialstate = {
    url: "", screenshots: []
}

function screenshots(state = initialstate, action) {
    switch (action.type) {
        case "set_screenshots":
            return  action.payload 
        case "reset_screenshots":
            return initialstate

        default:
            return state
    }
}

export default screenshots;